import { render, staticRenderFns } from "./ProducerReportsAvailability.vue?vue&type=template&id=8e4b14ac&"
import script from "./ProducerReportsAvailability.vue?vue&type=script&lang=js&"
export * from "./ProducerReportsAvailability.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports